import { FC } from 'react';
import { LocalizedTypography } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { Card, Divider, Stack, StackItem } from '@optimus-web/core';
import { Account } from '@mews-commander/data-access';
import { AccountName } from '../../../components/common/AccountName';
import { ResourceName } from '../../../components/reservation/ResourceName';

interface ReservationBasicInfoProps {
    owner: Account;
    resourceId: string;
}

export const ReservationBasicInfo: FC<ReservationBasicInfoProps> = ({ owner, resourceId }) => (
    <Card padding="300">
        <Stack distribution="space-between">
            <Stack vertical fill spacing="100">
                <LocalizedTypography textStyle="bodySmall" textKey={TextKey.Space} as="div" />
                <span>
                    <ResourceName resourceId={resourceId} />
                </span>
            </Stack>

            <StackItem width="40px">
                <Divider direction="vertical" />
            </StackItem>

            <Stack vertical fill spacing="100">
                <LocalizedTypography textStyle="bodySmall" textKey={TextKey.ReservationOwner} as="div" />
                <span>
                    <AccountName account={owner} reverse />
                </span>
            </Stack>
        </Stack>
    </Card>
);
